/*
    AI Automation Assistant / Plays User Property Names
*/
export const PLAY_FIRST_SOURCE = 'Play Source - First';
export const PLAY_SOURCES = 'Play Sources - All';
export const PLAY_SESSIONS_COUNT = 'Number of Play Sessions';
export const PLAYS_STARTED_COUNT = 'Number of Plays Started';
export const PLAYS_FINISHED_COUNT = 'Number of Plays Finished';
export const PLAYS_LAUNCHED_COUNT = 'Number of Plays Launched';
